/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthAccessDeniedRouteImport } from './routes/_auth/access-denied'
import { Route as AuthInvalidLinkRouteImport } from './routes/_auth/invalid-link'
import { Route as AuthInvitationRouteImport } from './routes/_auth/invitation'
import { Route as AuthLinkExpiredRouteImport } from './routes/_auth/link-expired'
import { Route as AuthLoginVerifyRouteImport } from './routes/_auth/login-verify'
import { Route as AuthMagicLinkSentRouteImport } from './routes/_auth/magic-link-sent'
import { Route as AuthSessionExpiredRouteImport } from './routes/_auth/session-expired'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthTooManyRequestsRouteImport } from './routes/_auth/too-many-requests.'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthAccessDeniedRoute = AuthAccessDeniedRouteImport.update({
  id: '/access-denied',
  path: '/access-denied',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvalidLinkRoute = AuthInvalidLinkRouteImport.update({
  id: '/invalid-link',
  path: '/invalid-link',
  getParentRoute: () => AuthRoute,
} as any)
const AuthInvitationRoute = AuthInvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLinkExpiredRoute = AuthLinkExpiredRouteImport.update({
  id: '/link-expired',
  path: '/link-expired',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginVerifyRoute = AuthLoginVerifyRouteImport.update({
  id: '/login-verify',
  path: '/login-verify',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMagicLinkSentRoute = AuthMagicLinkSentRouteImport.update({
  id: '/magic-link-sent',
  path: '/magic-link-sent',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSessionExpiredRoute = AuthSessionExpiredRouteImport.update({
  id: '/session-expired',
  path: '/session-expired',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthTooManyRequestsRoute = AuthTooManyRequestsRouteImport.update({
  id: '/too-many-requests/',
  path: '/too-many-requests/',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/access-denied': typeof AuthAccessDeniedRoute
  '/invalid-link': typeof AuthInvalidLinkRoute
  '/invitation': typeof AuthInvitationRoute
  '/link-expired': typeof AuthLinkExpiredRoute
  '/login-verify': typeof AuthLoginVerifyRoute
  '/magic-link-sent': typeof AuthMagicLinkSentRoute
  '/session-expired': typeof AuthSessionExpiredRoute
  '/sign-in': typeof AuthSignInRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/too-many-requests/': typeof AuthTooManyRequestsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/access-denied': typeof AuthAccessDeniedRoute
  '/invalid-link': typeof AuthInvalidLinkRoute
  '/invitation': typeof AuthInvitationRoute
  '/link-expired': typeof AuthLinkExpiredRoute
  '/login-verify': typeof AuthLoginVerifyRoute
  '/magic-link-sent': typeof AuthMagicLinkSentRoute
  '/session-expired': typeof AuthSessionExpiredRoute
  '/sign-in': typeof AuthSignInRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/too-many-requests': typeof AuthTooManyRequestsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_auth/access-denied': typeof AuthAccessDeniedRoute
  '/_auth/invalid-link': typeof AuthInvalidLinkRoute
  '/_auth/invitation': typeof AuthInvitationRoute
  '/_auth/link-expired': typeof AuthLinkExpiredRoute
  '/_auth/login-verify': typeof AuthLoginVerifyRoute
  '/_auth/magic-link-sent': typeof AuthMagicLinkSentRoute
  '/_auth/session-expired': typeof AuthSessionExpiredRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_auth/too-many-requests/': typeof AuthTooManyRequestsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/access-denied'
    | '/invalid-link'
    | '/invitation'
    | '/link-expired'
    | '/login-verify'
    | '/magic-link-sent'
    | '/session-expired'
    | '/sign-in'
    | '/dashboard'
    | '/too-many-requests/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/access-denied'
    | '/invalid-link'
    | '/invitation'
    | '/link-expired'
    | '/login-verify'
    | '/magic-link-sent'
    | '/session-expired'
    | '/sign-in'
    | '/dashboard'
    | '/too-many-requests'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_authenticated'
    | '/_auth/access-denied'
    | '/_auth/invalid-link'
    | '/_auth/invitation'
    | '/_auth/link-expired'
    | '/_auth/login-verify'
    | '/_auth/magic-link-sent'
    | '/_auth/session-expired'
    | '/_auth/sign-in'
    | '/_authenticated/dashboard'
    | '/_auth/too-many-requests/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/access-denied': {
      id: '/_auth/access-denied'
      path: '/access-denied'
      fullPath: '/access-denied'
      preLoaderRoute: typeof AuthAccessDeniedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invalid-link': {
      id: '/_auth/invalid-link'
      path: '/invalid-link'
      fullPath: '/invalid-link'
      preLoaderRoute: typeof AuthInvalidLinkRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invitation': {
      id: '/_auth/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof AuthInvitationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/link-expired': {
      id: '/_auth/link-expired'
      path: '/link-expired'
      fullPath: '/link-expired'
      preLoaderRoute: typeof AuthLinkExpiredRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login-verify': {
      id: '/_auth/login-verify'
      path: '/login-verify'
      fullPath: '/login-verify'
      preLoaderRoute: typeof AuthLoginVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/magic-link-sent': {
      id: '/_auth/magic-link-sent'
      path: '/magic-link-sent'
      fullPath: '/magic-link-sent'
      preLoaderRoute: typeof AuthMagicLinkSentRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/session-expired': {
      id: '/_auth/session-expired'
      path: '/session-expired'
      fullPath: '/session-expired'
      preLoaderRoute: typeof AuthSessionExpiredRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_auth/too-many-requests/': {
      id: '/_auth/too-many-requests/'
      path: '/too-many-requests'
      fullPath: '/too-many-requests/'
      preLoaderRoute: typeof AuthTooManyRequestsRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthAccessDeniedRoute: typeof AuthAccessDeniedRoute
  AuthInvalidLinkRoute: typeof AuthInvalidLinkRoute
  AuthInvitationRoute: typeof AuthInvitationRoute
  AuthLinkExpiredRoute: typeof AuthLinkExpiredRoute
  AuthLoginVerifyRoute: typeof AuthLoginVerifyRoute
  AuthMagicLinkSentRoute: typeof AuthMagicLinkSentRoute
  AuthSessionExpiredRoute: typeof AuthSessionExpiredRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthTooManyRequestsRoute: typeof AuthTooManyRequestsRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAccessDeniedRoute: AuthAccessDeniedRoute,
  AuthInvalidLinkRoute: AuthInvalidLinkRoute,
  AuthInvitationRoute: AuthInvitationRoute,
  AuthLinkExpiredRoute: AuthLinkExpiredRoute,
  AuthLoginVerifyRoute: AuthLoginVerifyRoute,
  AuthMagicLinkSentRoute: AuthMagicLinkSentRoute,
  AuthSessionExpiredRoute: AuthSessionExpiredRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthTooManyRequestsRoute: AuthTooManyRequestsRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
